import { Controller } from '@hotwired/stimulus'
import Swiper, { Navigation, Pagination, Lazy } from 'swiper/core'

Swiper.use([Navigation, Pagination, Lazy])
export default class extends Controller {
  static targets = ['rank']

  get className () {
    return this.element.dataset.classname
  }

  connect () {
    const options = {
      slidesPerView: 1,
      spaceBetween: 44,
      centeredSlides: true,
      lazyLoading: true,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        prevEl: '#swiperButtonPrev',
        nextEl: '#swiperButtonNext',
      },
    }

    // ドットページネーションはキャンペーン施設カセット（エリアページ）でのみ表示する。
    // このコンポーネントは検索結果・レコメンド・トップ等でも流用されており、
    // それらSPカルーセルの表示を変えないよう data-pagination-enabled で明示的に絞る。
    if (this.element.dataset.paginationEnabled === 'true') {
      options.pagination = {
        el: '.swiper-pagination',
        clickable: true,
        bulletActiveClass: `${this.className}::active`,
      }
    }

    const swiper = new Swiper(this.element, options)

    swiper.enable()

    const rank = this.rankTargets
    if (rank && rank.length > 0) {
      rank.forEach((target, index) => {
        target.textContent = (index + 1).toString()
      })
    }
  }
}
